import { computed } from "vue";
import { useToast } from "@/composables/ui/useToast";
import { useStore } from "vuex";
import { useBucketWebhooks } from "./useBucketWebhooks";
import { useAppStore } from "../app/useAppStore";
import { useRegisterBucket } from "./useBucket";
import { TaskType } from "@/utils/enums";
/**
 * Composable for handling call bucket prompt banner
 * Sets up socket event handler and bucket creation logic
 */
export function useCallBucketPrompt() {
  const { callBucketPrompt, showCallBucketPrompt, hideCallBucketPrompt } = useAppStore();

  const $toast = useToast();

  // Store for account
  const store = useStore();
  const account = computed(() => store.getters.account?.data);
  const organizationId = computed(() => account.value?.organizationId);

  // Bucket creation mutation
  const { mutateAsync: registerBucketMutation } = useRegisterBucket();

  // Setup socket event handler
  useBucketWebhooks({
    onBucketPromptManual: (payload) => {
      showCallBucketPrompt(payload);
    },
  });

  // Handle bucket creation
  const handleCreateBucket = async (bucketOptionId: string) => {
    if (!callBucketPrompt.value.contactId || !organizationId.value) {
      $toast?.error("Missing required information. Please try again.");
      return;
    }

    try {
      const today = new Date();
      const localMidnight = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        0,
        0,
        0,
        0
      );
      const followUpDate = localMidnight.toISOString();

      await registerBucketMutation({
        contactId: callBucketPrompt.value.contactId,
        bucketOptionId,
        taskType: TaskType.call,
        followUpDate,
        organizationId: organizationId.value,
      });

      $toast?.success("Task created successfully!");
      hideCallBucketPrompt();
    } catch (error: any) {
      console.error("Error creating bucket:", error);
      $toast?.error(
        error?.response?.data?.msg || error?.message || "Failed to create task. Please try again."
      );
    }
  };

  return {
    callBucketPrompt,
    hideCallBucketPrompt,
    handleCreateBucket,
  };
}
